"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxLayout = void 0;
var React = require("react");
var classNames = require("classnames");
var BoxLayout = /** @class */ (function (_super) {
    __extends(BoxLayout, _super);
    function BoxLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BoxLayout.prototype.calculateItemFlex = function (index) {
        var division = this.props.division;
        if (division && Array.isArray(division)) {
            var d = division[index];
            return d + ' ' + d + ' ' + d + 'px';
        }
        return '1 1 1px';
    };
    BoxLayout.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, direction = _a.direction, division = _a.division, gap = _a.gap, rest = __rest(_a, ["children", "className", "direction", "division", "gap"]);
        var childs = Array.isArray(children)
            ? children.filter(function (x) { return !!x; })
            : children;
        return (React.createElement("div", __assign({ className: classNames('sok-box-layout', 'sok-box-layout-' + (direction || 'row'), className) }, rest),
            React.createElement("div", { className: "sok-box-layout-inner" }, React.Children.map(childs, function (child, index) {
                return child && typeof child === 'object' ? (React.createElement("div", { className: "sok-box-layout-item", style: {
                        flex: _this.calculateItemFlex(index),
                        marginTop: !direction || direction === 'row' || index === 0
                            ? '0'
                            : gap || '2rem',
                        marginLeft: direction === 'column' ||
                            direction === 'col' ||
                            index === 0
                            ? '0'
                            : gap || '2rem'
                    } }, child)) : null;
            }))));
    };
    return BoxLayout;
}(React.Component));
exports.BoxLayout = BoxLayout;
//# sourceMappingURL=index.js.map